import { Group, Icon, Skeleton, Text, Title } from "components/common"
import theme from "utils/themeVars"
import { Col, List, Row } from "antd"
import cx from "clsx"
import styles from "./progressItem.module.less"

function ProgressItem({ stage, active, complete, disabled, onStageClick, loading, partiallyCompleted = false }) {
  return (
    <List.Item
      className={cx(
        styles.projectList,
        complete && styles.completed,
        active && styles.active,
        disabled && styles.disabled,
        partiallyCompleted && styles.partiallyCompleted
      )}
      onClick={onStageClick}
    >
      {loading ? (
        <>
          <div>
            <Skeleton size={"small"} width={2} height={8} type={"avatar"} />
          </div>
          <div>
            <Skeleton height={15} width={200} className="mbe-2" />
            <Skeleton height={15} width={200} />
          </div>
        </>
      ) : (
        <>
          <div className={styles.listIcon}>{stage?.icon}</div>
          <div>
            <Title level={5} className="mbe-2">
              {stage?.name}
            </Title>
            <Text type="secondary">{stage?.subText}</Text>
          </div>
          <div className={styles.checkIcon}>
            <Icon
              hasBackground
              icon="FaCheck"
              size="11px"
              style={{ borderRadius: "1rem", "--icon-color": theme["primary-color"], margin: -4 }}
              iconContainerStyle={{ translate: "0 3px", padding: 10, "--icon-bg-color": "#E7F3EF" }}
            />
          </div>
        </>
      )}
    </List.Item>
  )
}

export default ProgressItem
